import * as Types from '@trello/graphql/generated';

import { useQuickLoad } from '@trello/quickload';
import type { TrelloQueryHookOptions, TrelloLazyQueryHookOptions } from '@trello/quickload';
import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const MinimalCardFrontDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MinimalCardFront"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"card"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cardId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"MinimalCardFront","document":MinimalCardFrontDocument}} as const;
export type MinimalCardFrontQueryVariables = Types.Exact<{
  cardId: Types.Scalars['ID']['input'];
}>;


export type MinimalCardFrontQuery = (
  { __typename: 'Query' }
  & { card?: Types.Maybe<(
    { __typename: 'Card' }
    & Pick<Types.Card, 'id' | 'name' | 'url'>
  )> }
);

/**
 * __useMinimalCardFrontQuery__
 *
 * To run a query within a React component, call `useMinimalCardFrontQuery` and pass it any options that fit your needs.
 * When your component renders, `useMinimalCardFrontQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMinimalCardFrontQuery({
 *   variables: {
 *      cardId: // value for 'cardId'
 *   },
 * });
 */
export function useMinimalCardFrontQuery(
  baseOptions: TrelloQueryHookOptions<
    MinimalCardFrontQuery,
    MinimalCardFrontQueryVariables
  >,
) {
  const isQuickLoading = useQuickLoad({
    waitOn: baseOptions?.waitOn || ['None'],
    document: MinimalCardFrontDocument,
    skip: baseOptions?.skip,
  });
  const options = {
    ...defaultOptions,
    ...baseOptions,
    skip: isQuickLoading || baseOptions?.skip,
  };
  const result = Apollo.useQuery<
    MinimalCardFrontQuery,
    MinimalCardFrontQueryVariables
  >(MinimalCardFrontDocument, options);
  // reconstruct result because modifying the useQuery result actually changes apollo behavior because of memoization
  const trelloResult = { ...result };
  if (isQuickLoading) {
    trelloResult.loading = true;
  }

  return trelloResult;
}
export function useMinimalCardFrontLazyQuery(
  baseOptions?: TrelloLazyQueryHookOptions<
    MinimalCardFrontQuery,
    MinimalCardFrontQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    MinimalCardFrontQuery,
    MinimalCardFrontQueryVariables
  >(MinimalCardFrontDocument, options);
}
export type MinimalCardFrontQueryHookResult = ReturnType<
  typeof useMinimalCardFrontQuery
>;
export type MinimalCardFrontLazyQueryHookResult = ReturnType<
  typeof useMinimalCardFrontLazyQuery
>;
export type MinimalCardFrontQueryResult = Apollo.QueryResult<
  MinimalCardFrontQuery,
  MinimalCardFrontQueryVariables
>;
